/*
 * Authors: mariushirjanu
 * Created: 21/11/2023
 */
import { NgForOf } from '@angular/common';
import { Directive, Host, Input, NgIterable } from '@angular/core';

/**
 * @description Allow to set trackBy id for ngFor
 * @example <div *ngFor="let faqCode of faqCodes; trackById"></div>
 */

@Directive({
  selector: '[ngForTrackById]'
})
export class NgForTrackByIdDirective<T> {
  @Input() ngForOf:NgIterable<T>;

  constructor(@Host() public ngForOfDir:NgForOf<T>) {
    this.ngForOfDir.ngForTrackBy = (index:number, item:T) => {
      return item['id'] || index;
    };
  }
}